define('home/views/NotificationsView',[
    'underscore',

    'home/utils/sidebarUtils',

    'home/views/common/TabbedView',
    'home/views/common/FetchableCollectionLayout',
    'home/views/NotificationCardCollectionView',
    'home/views/MotdAlertView',
    'home/views/RecommendationsModuleView',

    'home/templates/notifications',
    'home/mixins/withClickLinkTracking',
    'home/mixins/withEmailVerificationAlert',
], function (
    _,

    sidebarUtils,

    TabbedView,
    FetchableCollectionLayout,
    NotificationCardCollectionView,
    MotdAlertView,
    RecommendationsModuleView,

    notificationsTemplate,
    withClickLinkTracking,
    withEmailVerificationAlert
) {
    'use strict';

    var NotificationsView = TabbedView.extend({
        defaultTab: 'all',
        template: notificationsTemplate,

        events: _.defaults({
            'click a[data-link-name]': 'trackClickLink',
        }, TabbedView.prototype.events),

        regions: _.defaults({
            recommendedUsersModuleRegion: '[data-role=recommend-module][data-recommend-type=user]',
            recommendedForumsModuleRegion: '[data-role=recommend-module][data-recommend-type=forum]',
            motdAlertRegion: '[data-role=motd-alert]',
        }, TabbedView.prototype.regions),

        onDomRefresh: function () {
            TabbedView.prototype.onDomRefresh.call(this);

            if (!this.options.onboardingWithoutChannels) {
                this.recommendedUsersModuleRegion.show(
                    RecommendationsModuleView.createUserRecommendedModuleView({ model: this.model.interestingUsers })
                );
                this.recommendedForumsModuleRegion.show(
                    RecommendationsModuleView.createForumRecommendedModuleView({ model: this.model.interestingForums })
                );
            }

            if (!this.options.disableMOTD)
                this.motdAlertRegion.show(new MotdAlertView());
        },

        getTrackingSection: function (activeTab) {
            // Return nothing for default tab
            return activeTab === 'replies' && activeTab;
        },

        getMetaAttrs: function () {
            return 'Notifications';
        },

        getTabView: function (activeTab) {
            var feed = this.model[activeTab];

            if (!feed)
                return;

            return new FetchableCollectionLayout({
                model: feed,
                collection: feed.get('items'),
                fetchableCollectionView: NotificationCardCollectionView,
                infiniteScroll: true,
            });
        },
    });

    withClickLinkTracking.call(NotificationsView.prototype);

    // don't show email verification if in sidebar
    if (!sidebarUtils.isSidebar())
        withEmailVerificationAlert.call(NotificationsView.prototype);

    return NotificationsView;
});

